import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-tree',
	templateUrl:'./WaTreePage.html',
	styles: [],
	styleUrls:['./WaTreePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaTreePage
{
	mdContent_481 = `\`\`\`java
import com.jwebmp.webawesome.components.tree.WaTree;
\`\`\``;
	mdContent_482 = `\`\`\`java
new WaTree<>()
\`\`\``;
	mdContent_483 = `\`\`\`java
var tree = new WaTree<>();
var item = new WaTreeItem<>();
item.setText("Documents");
var child = new WaTreeItem<>();
child.setText("report.pdf");
item.add(child);
tree.add(item);
\`\`\``;
}
